import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('homepage-component');

export const state = () => ({
    ...crud.state,

    NEWSBREAKER: 'newsbreaker',
    SLIDER: 'slider',
    TILE: 'tile'
});

export const getters = {
    ...crud.getters,

    ALL_TYPES: state => [
        {
            text: 'Newsbreaker',
            value: state.NEWSBREAKER
        },
        {
            text: 'Slides',
            value: state.SLIDER
        },
        {
            text: 'Tiles',
            value: state.TILE
        }
    ]
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    index(
        vuexContext,
        {
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters,
            type = null
        }
    ) {
        return axios.$get('/admin/homepage-components', {
            params: {
                page: currentPage,
                perPage,
                q: search,
                sortBy,
                order: descending ? 'DESC' : 'ASC',
                filters: JSON.stringify(filters),
                type
            }
        });
    }
};
